import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-none d-sm-flex" }
const _hoisted_2 = { class: "d-none d-sm-flex" }
const _hoisted_3 = { class: "d-none d-sm-flex" }
const _hoisted_4 = { class: "d-none d-sm-flex" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")
  const _component_router_link = _resolveComponent("router-link")
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")
  const _component_v_icon = _resolveComponent("v-icon")
  const _component_v_badge = _resolveComponent("v-badge")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_spacer = _resolveComponent("v-spacer")
  const _component_v_app_bar = _resolveComponent("v-app-bar")
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")
  const _component_v_list_item = _resolveComponent("v-list-item")
  const _component_v_list = _resolveComponent("v-list")
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app_bar, {
      density: "compact",
      elevation: "4",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          class: "d-flex d-sm-none",
          onClick: _cache[0] || (_cache[0] = $event => (_ctx.drawerOpen = !_ctx.drawerOpen))
        }),
        _createVNode(_component_v_toolbar_title, { class: "d-flex d-sm-none" }, {
          default: _withCtx(() => [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode("FAT BLACK CATS", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/cart",
          class: "d-flex d-sm-none"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, { icon: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_badge, {
                  content: _ctx.itemCount,
                  "model-value": _ctx.itemCount > 0,
                  color: "error"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-cart", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["content", "model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer, { class: "d-none d-sm-flex" }),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, null, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" FAT BLACK CATS ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/gigs" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, null, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" GIGS ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/merch" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode(" MERCH ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_router_link, { to: "/contactus" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, null, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode(" CONTACT US ", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_router_link, {
          to: "/cart",
          class: "d-none d-sm-flex"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, { icon: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_badge, {
                  content: _ctx.itemCount,
                  "model-value": _ctx.itemCount > 0,
                  color: "error"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                        _createTextVNode("mdi-cart", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["content", "model-value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_spacer, { class: "d-none d-sm-flex" })
      ]),
      _: 1
    }),
    _createVNode(_component_v_navigation_drawer, {
      modelValue: _ctx.drawerOpen,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.drawerOpen) = $event)),
      temporary: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_list, { nav: "" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list_item, {
              to: "/",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.drawerOpen = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                    _createTextVNode("FAT BLACK CATS", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_list_item, {
              to: "/gigs",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.drawerOpen = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("GIGS", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_list_item, {
              to: "/merch",
              onClick: _cache[3] || (_cache[3] = $event => (_ctx.drawerOpen = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("MERCH", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_list_item, {
              to: "/contactus",
              onClick: _cache[4] || (_cache[4] = $event => (_ctx.drawerOpen = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("CONTACT US", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}